import BaseProxy from './Proxy';

export default class SubstoreReturnFromOpenIdConnectProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/openid/return', parameters);
  }

  find(subscriptionTemplateId) {
    return this.submit('post', `${this.endpoint}/${subscriptionTemplateId}`);
  }

  returnFromOpenIdConnect(queryMap) {
    return this.submit('post', `${this.endpoint}`, queryMap);
  }
}
